import { writable } from "svelte/store";

// Create a writable store
export const isMobile = writable(window.innerWidth <= 768);

// Update the store value whenever the window is resized
window.addEventListener("resize", () => {
    isMobile.set(window.innerWidth <= 768);
});
